/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PartialParentRole } from './PartialParentRole';
import {
    PartialParentRoleFromJSON,
    PartialParentRoleFromJSONTyped,
    PartialParentRoleToJSON,
} from './PartialParentRole';

/**
 * 
 * @export
 * @interface ParentRoleAssociationRequest
 */
export interface ParentRoleAssociationRequest {
    /**
     * 
     * @type {Array<PartialParentRole>}
     * @memberof ParentRoleAssociationRequest
     */
    parentRoles: Array<PartialParentRole>;
}

/**
 * Check if a given object implements the ParentRoleAssociationRequest interface.
 */
export function instanceOfParentRoleAssociationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "parentRoles" in value;

    return isInstance;
}

export function ParentRoleAssociationRequestFromJSON(json: any): ParentRoleAssociationRequest {
    return ParentRoleAssociationRequestFromJSONTyped(json, false);
}

export function ParentRoleAssociationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentRoleAssociationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parentRoles': ((json['parentRoles'] as Array<any>).map(PartialParentRoleFromJSON)),
    };
}

export function ParentRoleAssociationRequestToJSON(value?: ParentRoleAssociationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parentRoles': ((value.parentRoles as Array<any>).map(PartialParentRoleToJSON)),
    };
}

